module.exports = __webpack_public_path__ + "static/media/AmbulanceIcon.670c9f07.png";